
// 小写字母
export function checkLowerCase (str) {
  const reg = /[a-z]/
  return reg.test(str)
}

// 大写字母
export function checkUpperCase (str) {
  const reg = /[A-Z]/
  return reg.test(str)
}

// 手机号
export function checkPhone (str) {
  const reg = /^(1[0-9][0-9]|14[57]|15[0-35-9]|18[07-9])\d{8}$/
  return reg.test(str)
}

// 邮箱
export function checkEmail (str) {
  // const reg = /^([a-zA-Z0-9])(\w|\-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
  // const reg = /^([a-zA-Z0-9])(\w|-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line
  return reg.test(str)
}

// 大小写字母加数字
export function checkAlphabets (str) {
  const reg = /[0-9]/
  return reg.test(str)
}

// 下划线命名转换成驼峰命名
export function underScore2camelCase (str) {
  return str.replace(/_([\w])/g, (match, p1) => {
    return p1.toUpperCase()
  })
}

// 驼峰命名转换成下划线命名
export function camelCase2underScore (str) {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase()
}

// 首字母大写
export function firstUpperCase (str) {
  let formatStr = underScore2camelCase(str)
  return formatStr.replace(/\b(\w)/g, function ($1) {
    return $1.toUpperCase()
  })
}

// 验证密码
export const validatePassword = (rule, value, callback) => {
  if (!value || value.length < 8 || !checkAlphabets(value) || !checkLowerCase(value) || !checkUpperCase(value) || value.length > 20) {
    callback(new Error('8到20个字符且需包含至少一个大写字符、小写字符或者数字'))
  } else {
    callback()
  }
}

export const validateUsername = (rule, value, callback) => {
  callback()
/*
  if (value) {
    login.userExists({target: rule.field, value: value}).then(res => {
      console.log('validateValue', res.data)
      if (res.data) {
        callback(new Error('用户名已被注册'))
      } else {
        callback()
      }
    })
  } else {
    callback(new Error('Required'))
  }
*/
}

export const validateEmail = (rule, value, callback) => {
  if (!checkEmail(value)) {
    callback(new Error('请输入正确Email格式'))
  } else {
    callback()
  }
  // callback()
  /*
  if (!validateEmail(value)) {
    callback(new Error('请填写正确的邮箱地址'))
  }
  */
  /*
  login.userExists({target: rule.field, value: value}).then(res => {
    if (res.data) {
      callback(new Error('邮箱地址已被注册'))
    } else {
      callback()
    }
  })
  */
}

export const validatePhoneNumber = (rule, value, callback) => {
  if (!checkPhone(value)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/common/form_validate.js